import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import { Link } from 'react-router';
import styles from './nav.css';

const { nav } = hh(h);

const Nav = (props) => (
    nav({className: styles.container, ...props }, [
        // h(Link, {to: '/', activeClassName: styles.active, className: styles.item}, 'For Students'),
        h(Link, {to: '/universities', activeClassName: styles.active, className: styles.item}, 'For Universities'),
        h(Link, {to: '/about', activeClassName: styles.active, className: styles.item}, 'About'),
        h(Link, {to: '/contact', activeClassName: styles.active, className: styles.item}, 'Contact')
    ])
);

export default Nav;



/** WEBPACK FOOTER **
 ** ./src/Nav/index.js
 **/